import { LoyaltyHVCLevelName } from '@/generated/graphql/types';

import { member, topMember } from './translations';

interface Props {
  levelToDisplay: LoyaltyHVCLevelName;
}

const getLevelNameTranslation = (level: string) => {
  switch (level) {
    case LoyaltyHVCLevelName.TOP_MEMBER:
      return topMember.format({
        i: (chunks: (string | JSX.Element)[]) => (
          <span key="highlight" className="text-loyalty-primary">
            {chunks}
          </span>
        ),
      });
    case LoyaltyHVCLevelName.MEMBER:
    default:
      return member;
  }
};

export const LoyaltyLevelLabel = ({ levelToDisplay }: Props) => (
  <div
    className="flex h-[20px] items-center justify-center rounded-tag
      bg-foundation-quinary px-xs text-tiny font-bold leading-small
      text-foundation-inverted tablet:text-small tablet:font-semibold"
  >
    {getLevelNameTranslation(levelToDisplay)}
  </div>
);

LoyaltyLevelLabel.displayName = 'LoyaltyLevelLabel';
